export default function Contact() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            投稿爆料
          </h2>
        </div>
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-500 to-primary-700 p-8 md:p-10">
          <div className="absolute top-0 right-0 w-72 h-72 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/4 blur-3xl"></div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-2xl md:text-3xl font-heading text-white mb-3">
                有猛料？来投稿！
              </h3>
              <p className="text-sm text-white/80 max-w-md leading-relaxed">
                如果你有网红塌房黑料、网曝门现场一手信息或独家爆料内容，欢迎联系51吃瓜黑料编辑部。我们会对投稿内容进行整理发布，让你的爆料被更多人看到。
              </p>
              <div className="flex flex-wrap items-center gap-4 mt-6 justify-center lg:justify-start">
                <div className="flex items-center gap-2 text-white/80 text-sm">
                  <i className="ri-mail-line text-lg"></i>
                  <span className="whitespace-nowrap">tougao@51chigua.xyz</span>
                </div>
                <div className="flex items-center gap-2 text-white/80 text-sm">
                  <i className="ri-wechat-line text-lg"></i>
                  <span className="whitespace-nowrap">51chigua_official</span>
                </div>
              </div>
              <button className="whitespace-nowrap mt-6 px-8 py-3 rounded-full bg-white text-primary-600 font-semibold text-sm hover:bg-white/90 transition-colors duration-200 cursor-pointer shadow-lg">
                立即投稿
              </button>
            </div>
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-white/10 flex items-center justify-center backdrop-blur-sm">
              <i className="ri-send-plane-2-line text-5xl text-white/60"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}